<div
  #mentionsHighlight
  *ngIf="formControl.value && formControl.value !== ''"
  [innerHTML]="state.valueHighlight"
  class="mentions"
></div>
<textarea
  #textarea
  #textInput="rtOverlayOrigin"
  [rtProtectedControl]="hasProtectedControl ? formControl : null"
  [rtProtectedControlName]="'rtu.candidate.team_notes' | translate"
  [rtProtectedControlOptions]="{ bailOn: ['dirty'], bailOnlyIfChanged: true }"
  [formControl]="formControl"
  [readOnly]="readOnly"
  [placeholder]="placeholder"
  (focus)="updateComponentWidth()"
  rt-overlay-origin
  class="content-input"
></textarea>

<ng-template
  [width]="state.componentWidth"
  [open]="state.dropdownOpen"
  [origin]="textInput"
  rt-connected-overlay
>
  <rt-dropdown
    [style.maxWidth]="'none'"
    [style.maxHeight]="'300px'"
    (scroll)="$event.stopPropagation()"
    rtScrollable
    class="search-list"
  >
    <rt-dropdown-item
      *ngFor="let admin of state.searchList; trackBy: trackByAdmin; let i = index"
      [class.selected]="state.searchItemIndex === i"
      (mousedown)="selectItem(i, $event)"
    >
      <div layout layout-horizontal layout-align-items-center>
        <rt-avatar
          [type]="'image'"
          [size]="'small'"
          [shape]="'oval'"
          [imageSrc]="admin.photoThumbUrl"
        >
        </rt-avatar>
        <span margin-left-small>{{ admin.firstName }} {{ admin.lastName }}</span>
      </div>
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
